module.exports = __webpack_public_path__ + "img/bg.514bc0a6.jpg";